import { css } from 'lit';

export default css`
  /* Write custom CSS here */
`;
